import React from 'react';
import { useI18n } from '../i18n/I18nContext';

export const HomeHero: React.FC = () => {
  const { t } = useI18n();

  return (
    <section className="bg-black">
      <div className="mx-auto max-w-7xl px-4 pb-0 sm:px-6 lg:px-8">
        <div className="relative overflow-hidden rounded-lg">
          <img src="/images/cinema-seats.jpg" alt={t('homeHeroImageAlt')} className="h-[300px] w-full object-cover object-bottom sm:h-[340px] lg:h-[350px]" />
          <div className="absolute inset-0 bg-gradient-to-r from-black via-black/70 to-black/10" />
          <div className="absolute inset-0 flex items-center px-5 py-8 sm:px-8 lg:px-12">
            <div className="max-w-2xl">
              <h1 className="max-w-2xl text-4xl font-bold text-white sm:text-5xl">{t('appName')}</h1>
              <p className="mt-3 w-fit rounded-md bg-[#ffd460] px-3 py-1 text-base font-semibold text-stone-950">{t('partnerLabel')}</p>
              <p className="mt-4 max-w-xl text-lg text-stone-300">{t('homeHeroText')}</p>
              <img src="/images/viu-logo.svg" alt="Viu" className="mt-5 h-8 w-fit" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

